import { Badge } from "@/components/ui/badge";
import { motion } from "framer-motion";

interface ToolCardCategoriesProps {
  categories: string[];
}

export const ToolCardCategories = ({ categories }: ToolCardCategoriesProps) => {
  return (
    <div className="flex-grow flex flex-wrap gap-2 justify-end max-h-[60px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-200 dark:scrollbar-thumb-gray-700">
      {categories.map((category) => (
        <motion.div
          key={category}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Badge 
            variant="secondary" 
            className="text-xs whitespace-nowrap bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary-foreground hover:bg-primary/20"
            onClick={(e) => e.stopPropagation()}
          >
            {category}
          </Badge>
        </motion.div>
      ))}
    </div>
  );
};